import type { ReactNode } from 'react';
import { cx } from '@/components/ui';
import { useAppShell } from '../AppShell/appShellContext';
import styles from './SideNav.module.css';

/** Full-color logo with the "IntellSchools" wordmark (public/images). */
export const BRAND_LOGO_SRC = '/images/intellschools-logo.png';

export interface SideNavBrandProps {
  productName?: string;
  /** Home link target. Omit for a non-link brand. */
  href?: string;
  renderLink?: (href: string, props: { className: string }, children: ReactNode) => ReactNode;
  collapsed?: boolean;
  className?: string;
}

/** IntellSchools logo; collapsed, it crops to the school building so it fits the narrow rail. */
export function SideNavBrand({
  productName = 'IntellSchools',
  href,
  renderLink,
  collapsed: collapsedProp,
  className,
}: SideNavBrandProps) {
  const shell = useAppShell();
  const collapsed = collapsedProp ?? shell?.collapsed ?? false;
  const content = (
    <img
      src={BRAND_LOGO_SRC}
      alt={productName}
      width={600}
      height={300}
      className={cx(styles.brandLogo, collapsed && styles.brandLogoCollapsed)}
    />
  );
  const classes = cx(styles.brand, className);

  if (!href) return <div className={classes}>{content}</div>;
  if (renderLink) return <>{renderLink(href, { className: classes }, content)}</>;
  return (
    <a href={href} className={classes}>
      {content}
    </a>
  );
}
